import React from 'react'

import { useSelector } from 'react-redux';
import { getBreadcrumbs } from 'store/slices/layoutSlice';

import { getFirstTitleFromBreadcrumbs } from 'utils/common';

import { ContentWrapper } from 'components/layout';

import { MenuTable } from './components/MenuTable';

const Menu = () => {
  const currentBreadcrumbs = useSelector(getBreadcrumbs);
  const title = getFirstTitleFromBreadcrumbs(currentBreadcrumbs);
  return (
    <ContentWrapper title={title}>
        <MenuTable />
    </ContentWrapper>
  )
}

export default Menu